import { Dispatch } from 'redux';
import { StoreState } from '../store-interfaces';
import { getActionHookBuilder } from './action-hook-builder';
import CrudActionContainer from './CrudActionContainer';
import XRayConfigurationController from '../controllers/XRayConfigurationController';
import commonHandler from '../errorHandlers/common-handler';

class XRayConfigurationCRUDActions extends CrudActionContainer {
  constructor() {
    super('XRAY_CONFIGURATION');
  }

  getXRayEventsConfiguration(
    ...params: Parameters<
      typeof XRayConfigurationController.getXrayEventsConfiguration
    >
  ) {
    return async (dispatch: Dispatch<StoreState>) => {
      try {
        dispatch(this.busy(this.retrieveAllAction));
        const res =
          await XRayConfigurationController.getXrayEventsConfiguration(
            ...params,
          );
        dispatch(this.retrievedAll([res]));
        return res;
      } catch (err) {
        commonHandler(dispatch)(err);
        return err;
      } finally {
        dispatch(this.unbusy());
      }
    };
  }
  updateXRayEventsConfiguration(
    ...params: Parameters<
      typeof XRayConfigurationController.updateXrayEventsConfiguration
    >
  ) {
    return async (dispatch: Dispatch<StoreState>) => {
      try {
        dispatch(this.busy(this.updateAction));
        const res =
          await XRayConfigurationController.updateXrayEventsConfiguration(
            ...params,
          );
        dispatch(this.updateLocal(res));
        return res;
      } catch (err) {
        commonHandler(dispatch)(err);
        return err;
      } finally {
        dispatch(this.unbusy());
      }
    };
  }

  testXRayEventsConfiguration(
    ...params: Parameters<
      typeof XRayConfigurationController.testXrayEventsConfiguration
    >
  ) {
    return async (
      dispatch: Dispatch<StoreState>,
    ): ReturnType<
      typeof XRayConfigurationController.testXrayEventsConfiguration
    > => {
      try {
        dispatch(this.busy());
        const res =
          await XRayConfigurationController.testXrayEventsConfiguration(
            ...params,
          );
        return res;
      } catch (err) {
        commonHandler(dispatch)(err);
        return err;
      } finally {
        dispatch(this.unbusy());
      }
    };
  }
}

export const xRayConfigurationCRUDActions = new XRayConfigurationCRUDActions();

export const useXRayConfigurationCRUDActions = getActionHookBuilder(
  xRayConfigurationCRUDActions,
  [
    'getXRayEventsConfiguration',
    'updateXRayEventsConfiguration',
    'testXRayEventsConfiguration',
  ],
);
